module.exports = "<header class=\"header CoverImage FlexEmbed FlexEmbed--3by1\" id=\"top-header\">\n    <div class=\"header-box wrapper\">\n        <a class=\"header-logo\" tabindex=\"-1\" ui-sref=\"site.homepage\" ng-include\n            src=\"'/assets/images/minto_logo_white.svg'\"></a>\n        <p ng-if=\"vm.title\" class=\"header-caption\" ng-bind=\"'header.' + vm.title | translate\"></p>\n        <p class=\"header-version\">{{vm.version}}</p>\n    </div>\n</header>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/header/header.html
// module id = 848
// module chunks = 0